import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const GALLERY = [
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/4jhnetlh_640%20%2834%29%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/z8ml0eey_640%20%2833%29%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/884oo55g_640%20%2835%29%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/lhtpdgfq_640%20%2827%29%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/c13bq36w_640%20%2829%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/aislkzgd_640%20%2830%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/asz818fb_640%20%2821%29%20%282%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/8ksqb6wd_640%20%2828%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/own07l5n_640%20%2825%29%20%282%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/fyed5zhn_640%20%2822%29%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/o4gin8kn_640%20%2815%29%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/pwufzu2l_640%20%2813%29%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/zsg0ntk4_640%20%2812%29%20%282%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/m9bc4sxc_640%20%2811%29%20%282%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/ka31cexe_640%20%2818%29%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/z0x128id_640%20%2817%29%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/v8txhpv1_640%20%2816%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/1abqsbpp_640%20%2814%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/l38tej65_640%20%284%29%20%282%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/cycrkm8h_640%20%281%29%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/vapct0bj_2026-05-04%2011.56.09%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/tza7nc53_640%20%287%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/ts63qd3c_640%20%286%29%20%282%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/4fm78mad_640%20%285%29%20%282%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/4lcay4st_2026-05-04%2011.56.03%20%282%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/y2errogj_2026-05-04%2011.59.12%20%282%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/gpt6zpcg_640%20%288%29%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/nwboslwj_640%20%282%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/nxwmxa6t_640%20%2819%29%20%282%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/36xtcyds_640%20%2810%29%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/1llr3zk3_640%20%289%29%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/bmr95pkb_640%20%2831%29%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/axotmhx8_640%20%2820%29%20%282%29.jpg",
];

const PER_PAGE = 14;

export default function Gallery() {
  const [active, setActive] = useState(0);
  const [page, setPage] = useState(0);
  const total = GALLERY.length;
  const pageCount = Math.ceil(total / PER_PAGE);

  // Auto-flip page to keep active thumb visible
  useEffect(() => {
    const p = Math.floor(active / PER_PAGE);
    if (p !== page) setPage(p);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);

  const go = (i) => setActive((i + total) % total);
  const pageStart = page * PER_PAGE;
  const pageThumbs = GALLERY.slice(pageStart, pageStart + PER_PAGE);

  return (
    <section
      id="gallery"
      className="py-20 lg:py-28 bg-[#FAFAFA]"
      data-testid="gallery-section"
    >
      <div className="max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-10">
        <p className="tc-eyebrow mb-3">Our Work</p>
        <h2 className="font-serif text-[34px] sm:text-[44px] lg:text-[52px] text-[#173B86] leading-[1.05] tracking-[-0.01em] mb-3">
          Real homes. Real results.
        </h2>
        <p className="text-[14.5px] sm:text-[15px] text-[#5b6a85] max-w-[640px] mb-10">
          A small selection of recent jobs across Seattle, Tacoma, and
          Bellevue.
        </p>

        <div className="max-w-[760px] mx-auto">
          {/* Main image */}
          <div
            className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden shadow-md bg-[#e8ecf3]"
            data-testid="gallery-main"
          >
            {GALLERY.map((src, i) => (
              <img
                key={src}
                src={src}
                alt={`Cleaning work ${i + 1}`}
                loading={i === 0 ? "eager" : "lazy"}
                className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
                  i === active ? "opacity-100" : "opacity-0"
                }`}
              />
            ))}

            <button
              type="button"
              onClick={() => go(active - 1)}
              aria-label="Previous"
              data-testid="gallery-prev"
              className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/95 hover:bg-white shadow-md flex items-center justify-center transition"
            >
              <ChevronLeft className="w-4 h-4 text-[#173B86]" />
            </button>
            <button
              type="button"
              onClick={() => go(active + 1)}
              aria-label="Next"
              data-testid="gallery-next"
              className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/95 hover:bg-white shadow-md flex items-center justify-center transition"
            >
              <ChevronRight className="w-4 h-4 text-[#173B86]" />
            </button>

            <div className="absolute bottom-3 right-3 bg-[#173B86]/90 text-white text-[11px] font-medium px-2.5 py-1 rounded-md">
              {active + 1} / {total}
            </div>
          </div>

          {/* Thumbnail grid (paginated) */}
          <div
            className="mt-4 grid grid-cols-5 sm:grid-cols-7 gap-2 sm:gap-2.5"
            data-testid="gallery-thumbs"
          >
            {pageThumbs.map((src, j) => {
              const i = pageStart + j;
              return (
                <button
                  key={src}
                  type="button"
                  onClick={() => setActive(i)}
                  aria-label={`View image ${i + 1}`}
                  data-testid={`gallery-thumb-${i}`}
                  className={`relative aspect-square rounded-md overflow-hidden border-2 transition-all ${
                    i === active
                      ? "border-[#173B86] scale-[0.94]"
                      : "border-transparent hover:border-[#cdd6e6] opacity-70 hover:opacity-100"
                  }`}
                >
                  <img
                    src={src}
                    alt=""
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                </button>
              );
            })}
          </div>

          {/* Pagination controls */}
          {pageCount > 1 && (
            <div
              className="mt-6 flex items-center justify-center gap-2 flex-wrap"
              data-testid="gallery-pagination"
            >
              <button
                type="button"
                onClick={() => setPage((p) => Math.max(0, p - 1))}
                disabled={page === 0}
                aria-label="Previous page"
                data-testid="gallery-page-prev"
                className="w-9 h-9 rounded-full border border-[#dde3ed] flex items-center justify-center hover:border-[#173B86] hover:bg-white transition disabled:opacity-40 disabled:cursor-not-allowed"
              >
                <ChevronLeft className="w-4 h-4 text-[#173B86]" />
              </button>

              {Array.from({ length: pageCount }).map((_, i) => (
                <button
                  key={i}
                  type="button"
                  onClick={() => setPage(i)}
                  aria-label={`Page ${i + 1}`}
                  aria-current={i === page ? "page" : undefined}
                  data-testid={`gallery-page-${i}`}
                  className={`min-w-[36px] h-9 px-3 rounded-full text-[13px] font-medium transition ${
                    i === page
                      ? "bg-[#173B86] text-white"
                      : "text-[#173B86] hover:bg-[#DCEBFB]"
                  }`}
                >
                  {i + 1}
                </button>
              ))}

              <button
                type="button"
                onClick={() => setPage((p) => Math.min(pageCount - 1, p + 1))}
                disabled={page >= pageCount - 1}
                aria-label="Next page"
                data-testid="gallery-page-next"
                className="w-9 h-9 rounded-full border border-[#dde3ed] flex items-center justify-center hover:border-[#173B86] hover:bg-white transition disabled:opacity-40 disabled:cursor-not-allowed"
              >
                <ChevronRight className="w-4 h-4 text-[#173B86]" />
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
